{
  "Earlier": "EARLIER",
  "noAnnouncements": "You will receive information about scheduled maintenance activities and product issues being fixed",
  "noAnnouncementsTitle": "Your Announcements will appear here"
} 
